import { css } from '@emotion/css';
import {StatusPublished} from 'Shared/backend/icons/StatusPublished';
import { theme } from 'Shared/backend/ThemeProvider';
import {Match,Switch} from 'solid-js';

export type StatusKey = 'published' | 'unpublished';

export interface IStatusIcons {
	status: StatusKey,
	scheduleDate?: XXX
}

export function StatusIcons(props: IStatusIcons)
{
	return (
		<div title={props.status=='published' ? 'Visible to the public' : 'Disabled'}>
			<Switch>
				<Match when={props.status == 'published'}>
					<StatusPublished class={css(theme().linkIcon)} />
				</Match>
				<Match when={true}>
					<StatusPublished class={css(theme().linkIcon)} fill='#ccc' />
				</Match>
			</Switch>
		</div>
	);
}
